/* eslint-disable react/no-multi-comp */
import loadable from '@loadable/component';
import React, { Component } from 'react';
// import { Helmet } from 'react-helmet';
import LazyHydrate from 'react-lazy-hydration';
import { isMobileSafari } from 'react-device-detect';
import get from 'lodash/get';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
// import { setBackUrl } from 'helpers/back-url-store';
// import localStorage from 'helpers/local-storage';
import contentBlock from 'containers/content-block';
import Container from 'components/container';
import AbstractSearchPage from 'components/view-map-search';
import { changeDevice } from 'components/view-map-search/view-search';
import Breadcrumbs from 'components/breadcrumbs';
import Row, { Col } from 'components/row';
import sensor from 'components/sensor';
import AdSense from 'components/adsense';
import { iconTypes } from 'components/icon';
// import { SeoText } from 'components/layouts';
import { OpenGraphImage } from 'components/image';

import linksDomik, { PAGE_ID } from 'src-sites/domik/links';
import blockConfig from 'src-sites/domik/blocks/config';
import BlockWrapper from 'src-sites/domik/blocks/block-wrapper';

// import renderMap from './render-map';
import viewTypes from './view-types';
import { cottageTownOrders, ordersLC } from './orders';
import { mapTile, sizeMap, idsChanged, outsideMapCard } from './common';

import translates from './search-i18n';

import MapCard from '../section-projects/tile-card';
import marker from '../assets/map-marker';

import 'styles/domik/section-projects/_page-search.scss';

const classesSearch = new Bem('pageSearch');

// *** Deferred load
const SearchForm = loadable(() => import(/* webpackChunkName: "searchForm" */ './search-form'));
export const OBJECTS_PER_PAGE = 24;

@sensor
@I18nHoc(translates())
export default class PageProjectList extends AbstractSearchPage {
  constructor(props, ctx) {
    super(props, ctx);

    this.project = 'domik';
    this.entity = 'location';

    this.searchByBbox = false;

    this.searchForm = SearchForm;
    this.advancedQueryParams = { unsold: true };
    this.viewTypes = viewTypes;
    this.customSearchHeader = {
      labelForOrder: '',
      iconForOrder: iconTypes.carretBild
    };
    this.mapLayerSwitchPosition = 'bottomleft';
    this.breadCrumbs = Dummy;
    this.preloadedDataProp = 'listData';
    this.objectsPerPage = OBJECTS_PER_PAGE;
    this.pageUrlBuilder = linksDomik.sectionLanding;
    this.urlPageId = PAGE_ID;
    this.delay = null;
    this.onResize = this.onHandleResize;

    this.state = {
      isFullScreenMode: false,
      isFullscreenMap: false,
      // fullMapLegend: true,
      // animatedMapLegend: false,
      handleMarkerId: null,
      device: 'desktop'
    };
  }

  componentDidMount() {
    super.componentDidMount();
    // setFullMapLegendState.call(this);//get data from localstorage
    // this._updateBackUrl(this.props);
    // this.onScroll(this.sensor.getRuntime());
    this.onHandleResize(this.sensor.getRuntime());
  }

  // componentDidUpdate() {
  //   this._updateBackUrl(this.props);
  // }

  // componentWillUnmount() {
  //   clearTimeout(this.autoCloseMapLegendDelay);
  //   clearTimeout(this.closeMapLegendDelay);
  // }

  // _updateBackUrl(props) {
  //   setBackUrl({ href: props.location.pathname, query: props.location.query });
  // }

  onHandleResize = ({ media: { desktop, tablet, phone } = {} }) => {
    changeDevice.call(this, desktop, tablet, phone);
  };

  // onScroll = (data) => {
  //   const viewPortHeight = get(data, 'viewPortHeight');
  //   const mapLegendRef = this.mapLegend ? this.mapLegend.getBoundingClientRect() : null;
  //   const mapLegendBottom = get(mapLegendRef, 'bottom');
  //
  //   if (
  //     isPhone(data) &&
  //     mapLegendBottom <= viewPortHeight &&
  //     localStorage.get('fullMapLegend') !== false
  //   ) {
  //     this.autoCloseMapLegendDelay = setTimeout(() => this.changeMapLegendView(), 5000);
  //   }
  // };

  handleIdsChanged = ids => idsChanged.call(this, ids);

  clickOutsideMapCard = evt => outsideMapCard.call(this, evt);

  mapTileRenderer = payload => mapTile.call(this, payload, MapCard);

  changeSizeMap = () => sizeMap.call(this, isMobileSafari);

  // changeMapLegendView = () => mapLegendView.call(this);

  getOrders(query) {
    if (!query) return null;

    // *** Order for projects
    const type = get(query, 'objectGroup');
    return type === 'cottageTowns' ?
      cottageTownOrders.call(this) :
      ordersLC.call(this);
  }

  renderSearchContentBlock(name) {
    return contentBlock(blockConfig, name, this.props, { classNameWrapper: name });
  }

  afterItemsContent = () => {
    return [
      this.renderSearchContentBlock('blockPSearch1'),
      this.renderSearchContentBlock('blockPSearch2'),
      this.renderSearchContentBlock('blockPSearch3'),
      this.renderSearchContentBlock('blockPSearch4')
    ];
  };

  mapMarkerCentralRenderer(feature) {
    return marker('standartBig');
  }

  mapMarkerRenderer(feature) {
    return marker('standart');
  }

  renderLayout = (params) => {
    // const { i18n } = this;
    const { params: { landing: { breadcrumbs } /* , url */ } /*, seoData*/ } = this.props;
    // console.log('lolo', this.props);
    // const siteName = i18n('siteName');
    // const seoPropPage = { itemScope: ' ', itemType: 'https://schema.org/SearchResultsPage' };
    // const seoText = get(seoData, 'bottomText', null);

    return (
      <>
        <LazyHydrate whenIdle>
          {/*
          <Helmet>
            <meta property="og:site_name" content={siteName} />
          </Helmet>
          */}
          {params.form({ landing: this.props.landing })}
        </LazyHydrate>
        <Container
          body
          // seoProps={seoPropPage}
        >
          {/* url && <meta itemProp="url" content={url} /> */}
          <Row {...classesSearch('row', 'main')}>
            <Col {...classesSearch('col', 'paginator')} allFlex allColumn allPr={0} children={params.paginator()} />
          </Row>
          <AdSense />
        </Container>
        <LazyHydrate whenVisible>
          {contentBlock(blockConfig, 'search2', this.props, { wrapper: BlockWrapper, withContainer: false, gtmProps: { 'place': 'Catalog' }, location: get(this, 'props.location') })}
          {contentBlock(blockConfig, 'search3', this.props, { wrapper: BlockWrapper, withContainer: false, gtmProps: { 'place': 'Catalog' }, location: get(this, 'props.location') })}
          {contentBlock(blockConfig, 'search4', this.props, { wrapper: BlockWrapper, withContainer: false, gtmProps: { 'place': 'Catalog' }, location: get(this, 'props.location') })}
          {contentBlock(blockConfig, 'search5', this.props, { wrapper: BlockWrapper, withContainer: false, gtmProps: { 'place': 'Catalog' }, location: get(this, 'props.location') })}
          {contentBlock(blockConfig, 'search6', this.props, { wrapper: BlockWrapper, withContainer: false, gtmProps: { 'place': 'Catalog' }, location: get(this, 'props.location') })}
        </LazyHydrate>
        <Container body>
          <Breadcrumbs
            data={breadcrumbs}
            // seoProps={{ itemProp: 'breadcrumb' }}
          />
          {/* <SeoText data={seoText} /> */}
        </Container>
        {contentBlock(blockConfig, 'search7', this.props, { withContainer: false, gtmProps: { 'place': 'Catalog' } })}
      </>
    );
  };

  render() {
    return (
      <>
        <LazyHydrate ssrOnly>
          <OpenGraphImage />
        </LazyHydrate>
        {this.renderSearchView()}
      </>
    );
  }
}

class Dummy extends Component {
  render() {
    return (<span>Dummy</span>);
  }
}
